import { createService } from "./createService"
import { SERVICE_INSTANCES } from "./serviceInstances"

const service = createService(SERVICE_INSTANCES.roles)

export const ROLE_INSTANCE = service.instanceKey

export const ROLE_ENDPOINTS = {
  SELECT_ROLE_DETAILS: "/admin/roles/select_role_details",
  VIEW_EDIT: "/admin/roles/view/edit",
  SELECT_PERMISSIONS: "/admin/roles/select_permissions",
  UPDATE: "/admin/roles/update",
  CREATE: "/admin/roles/create",
  UPDATE_USERS: "/admin/roles/update_users",
  ADD_USERS: "/admin/roles/add_users",
  REMOVE_USERS: "/admin/roles/remove_users",
  DELETE: "/admin/roles/delete",
} as const

export const roleService = {
  instanceKey: service.instanceKey,
  selectRoleDetails: (params?: { is_default?: boolean; [key: string]: any }) =>
    service.get(ROLE_ENDPOINTS.SELECT_ROLE_DETAILS, { ...params }),
  viewEdit: (id: string) => service.get(ROLE_ENDPOINTS.VIEW_EDIT, { id }),
  selectPermissions: () => service.get(ROLE_ENDPOINTS.SELECT_PERMISSIONS),
  update: (body: Record<string, any>) =>
    service.put(ROLE_ENDPOINTS.UPDATE, body),
  create: (body: Record<string, any>) =>
    service.post(ROLE_ENDPOINTS.CREATE, body),
  updateUsers: (body: Record<string, any>) =>
    service.put(ROLE_ENDPOINTS.UPDATE_USERS, body),
  addUsers: (body: Record<string, any>) =>
    service.post(ROLE_ENDPOINTS.ADD_USERS, body),
  removeUsers: (body: Record<string, any>) =>
    service.post(ROLE_ENDPOINTS.REMOVE_USERS, body),
  remove: (id: string | number, comment: string) =>
    service.delete(
      `${ROLE_ENDPOINTS.DELETE}?id=${id}&comment=${encodeURIComponent(comment)}`
    ),
}
